// extracted by mini-css-extract-plugin
export default {"modalBodyScroll":"AppleCookiePolicyModal_modalBodyScroll__j30SQ"};